// Metadatos de cada agregador para el panel "Llaves y API" del Admin.
// Cada entrada describe: nombre interno (clave), nombre externo (marca),
// dominio principal donde se gestiona la cuenta/API, y —cuando el agregador
// es una marca blanca/derivada de una plataforma mayor— el proveedor y su
// dominio (ej. Interpack y SoloEnvios provienen de Skydropx;
// SigoMx, GeniEnvios y MultiPaq provienen de Hydraship).
export const AGGREGATOR_META = {
  bhgc:        { internalName: "bhgc",       externalName: "BHGC Nexus Logistics",                  accountDomain: "bhgcnexuslogistics.com" },
  mydhl:       { internalName: "sgm",        externalName: "DHL Express (SGM)",                     accountDomain: "mydhl.express" },
  envia:       { internalName: "envia",      externalName: "Tendencys (Envia)",                     accountDomain: "envia.com" },
  pak2go:     { internalName: "pak2go",     externalName: "Epak (Pak2Go)",                          accountDomain: "pak2go.com" },
  interpack:   { internalName: "interpack",  externalName: "Envíos Internacionales (Interpack) — marca blanca de Skydropx Pro", accountDomain: "app.skydropx.com", providerName: "Skydropx (Skydropx Pro)", providerDomain: "skydropx.com" },
  skypractico: { internalName: "skypractico", externalName: "SkyPractico",                           accountDomain: "skypractico.com",   providerName: "Skydropx (Skydropx Pro)", providerDomain: "skydropx.com" },
  srsimi:      { internalName: "srsimi",     externalName: "SrSimi (DrEnvio)",                       accountDomain: "drenvio.com" },
  elogicya:    { internalName: "elogicya",   externalName: "ELogicYa (EnviaYa)",                     accountDomain: "enviaya.com.mx" },
  enviot2:     { internalName: "enviot2",    externalName: "EnvioT2 (T1Envios)",                     accountDomain: "t1.com" },
  sigomx:      { internalName: "sigomx",    externalName: "SigoMx (SIGYLMEX)",                      accountDomain: "app.sigylmex.com.mx", providerName: "Hydraship", providerDomain: "hydraship.app" },
  shipwoo:     { internalName: "shipwoo",    externalName: "ShipWoo (WeShip)",                      accountDomain: "weship.com" },
  genienvios:  { internalName: "genienvios", externalName: "GeniEnvios (EnvioGenial)",               accountDomain: "app.enviogenial.com", providerName: "Hydraship", providerDomain: "hydraship.app" },
  multipaq:    { internalName: "multipaq",   externalName: "MultiPaq (MultiGuia)",                   accountDomain: "app.multiguia.mx",  providerName: "Hydraship", providerDomain: "hydraship.app" },
  slenvios:    { internalName: "slenvios",   externalName: "SLEnvios (SoloEnvios)",                  accountDomain: "app.soloenvios.com", providerName: "Skydropx",                providerDomain: "skydropx.com" },
  gmx:         { internalName: "gmx",        externalName: "Gmx (Guiamx)",                            accountDomain: "app.guiasmx.com" },
  enviocohete: { internalName: "enviocohete", externalName: "Turbo Envíos (EnvioCohete)",               accountDomain: "app.turboenvios.mx" },
  aftership:   { internalName: "aftership", externalName: "AfterShip (Shipping + Tracking)",          accountDomain: "aftership.com" },
};

// Línea compacta de texto con toda la información del agregador.
// Útil para subtítulos, tooltips y exportes. Retorna "" si no hay metadata.
// Esquema de campos de credenciales por agregador. Define qué campos pide el
// modal de multi-convenio al crear/editar un convenio de cada agregador.
// type: 'text' (default), 'password', 'select', 'email'
// required: true = campo obligatorio para que el convenio funcione
export const AGG_CRED_SCHEMA = {
  envia: [
    { field: 'token', label: 'Token', required: true },
    { field: 'mode', label: 'Modo', type: 'select', options: ['test', 'production'] },
    { field: 'secret_key', label: 'Webhook Secret' },
  ],
  pak2go: [
    { field: 'api_key', label: 'API Key', required: true },
  ],
  interpack: [
    { field: 'client_id', label: 'Client ID', required: true },
    { field: 'client_secret', label: 'Client Secret', required: true },
    { field: 'mode', label: 'Modo', type: 'select', options: ['test', 'production'] },
    { field: 'token', label: 'Webhook Secret' },
  ],
  skypractico: [
    { field: 'client_id', label: 'Client ID', required: true },
    { field: 'client_secret', label: 'Client Secret', required: true },
    { field: 'mode', label: 'Modo', type: 'select', options: ['test', 'production'] },
    { field: 'token', label: 'Webhook Secret' },
  ],
  srsimi: [
    { field: 'token', label: 'Token', required: true },
    { field: 'mode', label: 'Modo', type: 'select', options: ['test', 'production'] },
  ],
  elogicya: [
    { field: 'api_key', label: 'API Key', required: true },
    { field: 'mode', label: 'Modo', type: 'select', options: ['test', 'production'] },
    { field: 'token', label: 'Account' },
    { field: 'secret_key', label: 'Webhook Secret' },
  ],
  sigomx: [
    { field: 'api_key', label: 'API Key', required: true },
  ],
  enviot2: [
    { field: 'api_key', label: 'API Key', required: true },
    { field: 'shop_id', label: 'Shop ID' },
    { field: 'mode', label: 'Modo', type: 'select', options: ['test', 'production'] },
    { field: 'base_url', label: 'Base URL' },
    { field: 'username', label: 'Username' },
    { field: 'password', label: 'Password', type: 'password' },
  ],
  shipwoo: [
    { field: 'api_key', label: 'API Key', required: true },
    { field: 'email', label: 'Email', type: 'email' },
    { field: 'mode', label: 'Modo', type: 'select', options: ['test', 'production'] },
  ],
  genienvios: [
    { field: 'api_key', label: 'API Key', required: true },
  ],
  multipaq: [
    { field: 'api_key', label: 'API Key', required: true },
  ],
  slenvios: [
    { field: 'client_id', label: 'Client ID', required: true },
    { field: 'client_secret', label: 'Client Secret', required: true },
    { field: 'mode', label: 'Modo', type: 'select', options: ['test', 'production'] },
  ],
  gmx: [
    { field: 'client_id', label: 'Client ID', required: true },
    { field: 'client_secret', label: 'Client Secret', required: true },
    { field: 'scope', label: 'Scope' },
    { field: 'mode', label: 'Modo', type: 'select', options: ['test', 'production'] },
  ],
  enviocohete: [
    { field: 'api_key', label: 'API Key (Bearer)', required: true },
    { field: 'mode', label: 'Modo', type: 'select', options: ['test', 'production'] },
  ],
  aftership: [
    { field: 'api_key', label: 'API Key (as-api-key)', required: true },
    { field: 'mode', label: 'Modo', type: 'select', options: ['test', 'production'] },
  ],
  bhgc: [],
  mydhl: [],
};

export function aggMetaLine(key) {
  const m = AGGREGATOR_META[key];
  if (!m) return "";
  let line = `Interno: ${m.internalName} · Externo: ${m.externalName} · Cuenta API: ${m.accountDomain}`;
  if (m.providerName) line += ` · Plataforma: ${m.providerName} (${m.providerDomain})`;
  return line;
}